import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";



const initialState = {
    penilaianGuru: {},
    detailPenilaianGuru: {},
    currentPage: 1,
    keterangan: null,
    urutan: {
        column: 'nama',
        order: 'asc'
    },
    search: '',


    errors: {
        nama: '',
        email: '',
        password: '',
        kelas: '',
    },

    listTeachers:[],

    isInitialGet: false,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,

    isLoading: true,
    isLoadingDetail: true,
};

export const getPenilaianGuru = createAsyncThunk("penilaianguru/getPenilaianGuru", async ({ search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/penilaian-guru',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


export const getDetailPenilaianGuru = createAsyncThunk("penilaianguru/getDetailPenilaianGuru", async ( id , { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/penilaian-guru' + `/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },

                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

const penilaianGuruSlice = createSlice({
    name: 'jadwalguru',
    initialState,
    reducers: {

        updateStatePenilaianGuru: (state, action) => {

            const { name, value } = action.payload
            state[name] = value
        },


        resetTable: (state) => {
            state.listPenilaianGuru = []
            state.isLoading = true
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getPenilaianGuru.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(getPenilaianGuru.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.penilaianGuru = action.payload.data;
                state.listTeachers = action.payload.data.teachers;
                state.isInitialGet = true
            })
            .addCase(getPenilaianGuru.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(getDetailPenilaianGuru.pending, (state) => {

                state.isLoadingDetail = true;
            })
            .addCase(getDetailPenilaianGuru.fulfilled, (state, action) => {

                state.isLoadingDetail = false;
                state.detailPenilaianGuru = action.payload.data;
                state.isInitialGet = true
            })
            .addCase(getDetailPenilaianGuru.rejected, (state, action) => {
                state.isLoadingDetail = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })





    }
});

export const {
    updateFieldValue, updateFieldError, resetForm, updateClassSiswa,setFormLoading, resetField, resetTable,
    setImgUpload, updateStatePenilaianGuru,deleteKelas, updateStateSiswa, resetListSiswa, showFormError
} = penilaianGuruSlice.actions;
export default penilaianGuruSlice.reducer;